export default __webpack_public_path__ + "static/media/04 Personal Details – 1@3x.97b20414.png";